import {  
  loadToolTipDataInProgress,
  loadToolTipDataSuccess,
  loadToolTipDataFailure,
  toolTipOperationCompleted,
  closeTooltipDialog,
  loadLastEventId,
  loadEventTooltipData,
} from "../state/tooltips/actions";
import swal from 'sweetalert';
import { errorSweetAlert, oopsSweetAlert } from '../components/SweetAlertMessages';
import { oktaAuth } from '../auth/okta';
const serverBasePath    =   process.env.REACT_APP_SERVER_API_URL;
let abortController = null;

export const createEventTooltip = (data) => async (dispatch) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
    dispatch(loadToolTipDataInProgress());
    try {
        const response = await fetch(serverBasePath+"/tooltip/create", {
            method: "POST",  
            headers: {
                Authorization: 'Bearer ' + token,       
                //'type': 'formData',
            },
            body:data
        });
        const result = await response.json();
        dispatch(toolTipOperationCompleted());
        if(response.status !== 200){
            oopsSweetAlert(result);
            return;
        }
        dispatch(closeTooltipDialog());
        swal({
            title: "Success",
            text: result.message,
            icon: "success",
            closeOnClickOutside:false,
            closeOnEsc: false,
            allowOutsideClick: false,
          })
          .then(marked => {
            if (marked) {
                dispatch(loadEventTooltips(''));
            }
        });
    } catch (e) {
        dispatch(loadToolTipDataFailure());
        errorSweetAlert(e);
    }
};


export const loadEventTooltips = (searchText,page=0,pageSize=10) => async (dispatch) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
    if (abortController) {
        abortController.abort();
    }
    abortController = new AbortController();
    const signal = abortController.signal;
    try {
        dispatch(loadToolTipDataInProgress());
        const response = await fetch(serverBasePath+"/tooltip/list?searchText="+searchText+"&page="+page+"&pageSize="+pageSize,
        {  
            signal,  
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            }
        });
        const result = await response.json();
        dispatch(toolTipOperationCompleted());
        if(response.status !== 200){
            oopsSweetAlert(result);
            return;
        }
        dispatch(loadToolTipDataSuccess(result));    
    } catch (e) {
        dispatch(loadToolTipDataFailure());   
        if (e.name === "AbortError") {
           // errorSweetAlert({message:'The operation was aborted.'}); 
        }
    }
};



export const deleteEventToolTip = (rowId,searchText) =>  {
    return async (dispatch) => {
        const token = oktaAuth.getAccessToken();
        if (!token) throw new Error('No access token');
        try {
            dispatch(loadToolTipDataInProgress());
            const response = await fetch(serverBasePath+"/tooltip/delete/"+rowId,{
            method: "PUT",
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            }}); 
            const result = await response.json();
            dispatch(toolTipOperationCompleted());
            if(response.status !==  200){
                oopsSweetAlert(result);
                return;
            }
        } catch (e) {   
            dispatch(loadToolTipDataFailure());
            errorSweetAlert(e);
        }
    };
};


export const loadEventId = () => async (dispatch) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
    try {
        dispatch(loadToolTipDataInProgress());
        const response = await fetch(serverBasePath+"/tooltip/getlastEventId",
        {     
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            }
        }); 
        const result = await response.json();
        dispatch(toolTipOperationCompleted());
        if(response.status !== 200){
            oopsSweetAlert(result);
            return;
        }
        dispatch(loadLastEventId(result?.data));    
    } catch (e) {
        dispatch(loadToolTipDataFailure());   
        errorSweetAlert(e);
    }
};


export const editTooltipData = (rowId) => async (dispatch) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
    try {
        dispatch(loadToolTipDataInProgress());
        const response = await fetch(serverBasePath+"/tooltip/getToolTip/"+rowId,
        {     
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            }
        });
        const data = await response.json();
        dispatch(toolTipOperationCompleted());
        if(response.status !== 200){
            oopsSweetAlert(data);
            return;
        }
        
        dispatch(loadEventTooltipData(data));   
    } catch (e) {
        dispatch(loadToolTipDataFailure());   
        errorSweetAlert(e);
    }
};

export const editEventTooltip = (data) => async (dispatch) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
    dispatch(loadToolTipDataInProgress());
    try {
        const response = await fetch(serverBasePath+"/tooltip/edit", {
            method: "PUT",  
            headers: {
                Authorization: 'Bearer ' + token,       
                //'type': 'formData',
            },
            body:data
        });
        const result = await response.json();
        dispatch(toolTipOperationCompleted());
        if(response.status !== 200){
            oopsSweetAlert(result);
            return;
        }
        dispatch(closeTooltipDialog());
    } catch (e) {
        dispatch(loadToolTipDataFailure());
        errorSweetAlert(e);
    }
};
